import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { activityAPI } from '../lib/api';

// Ping de présence pour mesurer le TEMPS DE TRAVAIL RÉEL (Flux d'activité).
// Envoie un heartbeat tant que l'onglet est authentifié ET visible (Page
// Visibility API), avec le chemin courant pour la ventilation par page. Le
// backend borne l'écart entre deux pings, donc un onglet fermé/masqué ne compte
// pas. Best-effort : toute erreur réseau est silencieusement ignorée.
const INTERVAL_MS = 60000;

export default function useActivityHeartbeat() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const pathRef = useRef(location.pathname);
  pathRef.current = location.pathname;

  useEffect(() => {
    if (!isAuthenticated) return undefined;
    let stopped = false;
    const ping = () => {
      if (stopped) return;
      if (typeof document !== 'undefined' && document.visibilityState !== 'visible') return;
      activityAPI.heartbeat(pathRef.current).catch(() => {});
    };
    ping();
    const id = setInterval(ping, INTERVAL_MS);
    // Au passage masqué (bascule d'onglet, minimisation) ET à la fermeture,
    // on envoie un flush final pour comptabiliser la dernière fraction de minute
    // (et les sessions < 1 min), via un fetch keepalive qui survit au déchargement.
    const onVisibility = () => {
      if (document.visibilityState === 'visible') ping();
      else activityAPI.heartbeatFlush(pathRef.current);
    };
    const onPageHide = () => activityAPI.heartbeatFlush(pathRef.current);
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('pagehide', onPageHide);
    return () => {
      stopped = true;
      clearInterval(id);
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('pagehide', onPageHide);
    };
  }, [isAuthenticated]);
}
